import EndOfArticleContext from '@contexts/endOfArticleContext'
import { useContext } from 'react'

const useIsEndOfArticle = (): boolean => !!useContext(EndOfArticleContext)

export default useIsEndOfArticle
